<template>
	<el-drawer :model-value="isShowUser" @update:model-value="updateIsShowUser" title="个人中心" size="30%" destroy-on-close @closed="closeUser">
		<div class="user-content">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane
					v-for="(item, index) in tabsList"
					:key="index"
					:label="item.label"
					:name="item.label"
				>
					<info
						v-loading="loading"
						:info="userInfoAll"
						v-if="item.label == '个人信息' && item.label == activeName"
					></info>
					<setting
						v-loading="loading"
						:info="userInfoAll"
						v-if="item.label == '个人设置' && item.label == activeName"
					></setting>
				</el-tab-pane>
			</el-tabs>
		</div>
	</el-drawer>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import info from './info'
import setting from './setting'

// Props
const props = defineProps({
	isShowUser: {
		type: Boolean,
		default: false
	},
	loading: {
		type: Boolean,
		default: false
	},
	userInfoAll: {
		type: Object,
		default: () => ({})
	}
})

// Reactive data
const activeName = ref('个人信息')
const tabsList = ref([
	{
		label: '个人信息'
	},
	{
		label: '个人设置'
	}
])

// Emits
const emit = defineEmits([
	'update:isShowUser',
	'close-user',
	'handle-click',
	'refresh-user-info'
])

// Methods
const updateIsShowUser = (value) => {
	emit('update:isShowUser', value)
}

const closeUser = () => {
	activeName.value = '个人信息'
	emit('close-user')
}

const handleClick = (e) => {
	activeName.value = e.props.name
	emit('handle-click', e)
}

// Watch
watch(
	() => props.isShowUser,
	(newVal) => {
		if (newVal) {
			// 当个人中心打开时，触发刷新用户信息
			emit('refresh-user-info')
		}
	}
)

</script>

<style scoped lang="scss">
.user-content :deep(.el-tabs__item.is-active) {
	color: rgba(100, 148, 237, 1);
	background-color: #d9ecff;
}

/* 去掉下划线 */
.user-content :deep(.el-tabs__active-bar) {
	background-color: transparent !important;
}

.user-content :deep(.el-tabs__item) {
	display: flex;
	justify-content: center;
	padding: 0 20px !important;
	border-radius: 25px;
	height: 35px;
}
</style> 